import { dialogs } from '../helpers';
export const getDialogByType = (modalType) => dialogs.get(modalType);
